import type { useHead } from 'nuxt/app'

type SeoData = {
  title?: string
  description?: string
  keywords?: string
}

/**
 * Формирует canonical и Open Graph meta-теги страницы.
 *
 * @param domain - домен сайта без протокола
 * @param seo - SEO-данные страницы
 * @param fullPath - полный путь страницы, включая query
 * @param path - canonical path без query
 * @returns типизированный объект для Nuxt `useHead`
 */
export const createSeoHead = (
  domain: string,
  seo: SeoData | null,
  fullPath: string,
  path: string,
): Parameters<typeof useHead>[0] => ({
  title: seo?.title,
  link: [{ rel: 'canonical', href: `https://${domain}${path}` }],
  meta: [
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:url',
      content: `https://${domain}${fullPath}`,
    },
    {
      property: 'og:image',
      content: `https://${domain}/farfor-og-image.png`,
    },
    ...(seo?.title
      ? [
          {
            property: 'og:title',
            content: seo.title,
          } as const,
        ]
      : []),
    ...(seo?.description
      ? [
          {
            property: 'og:description',
            content: seo.description,
          } as const,
          {
            name: 'description',
            content: seo.description,
          } as const,
        ]
      : []),
    ...(seo?.keywords
      ? [
          {
            name: 'keywords',
            content: seo.keywords,
          } as const,
        ]
      : []),
  ],
})
